import * as React from 'react';
import {ModulesBasic, IPropsBasic, ModulesRoot} from 'kts-scaffold-framework/modules';
import {connect} from 'kts-platform-frame/redux';
import ReduxState, {} from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import ICompanyInfo from './ICompanyInfo';
import {Urls} from 'kts-platform-frame/entry/constant';
import {Spin, Checkbox, Select, Radio, Input, Button, Layout, Icon} from 'antd'; 
import CompanyRaido from './CompanyRadio';
import CompanyCheck from './CompanyCheck';
// import {CompanyContainer} from './CompanyContainer';
const CheckboxGroup = Checkbox.Group;
const {Option, OptGroup} = Select;
const { Header, Footer, Content } = Layout;
const Search = Input.Search;
const RadioGroup = Radio.Group;
const css = require('./index.scss');  
/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map <Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart,IPropsBasic {

    /** 数据请求 */
    request?: (params?: IRequestParams) => Promise <any[]>;

    /** 用户选择了公司(默认组件内函数) */
    onChange?: (list: any[]) => void;
    onSubmitCompany?: (list: any[]) => void;
    /** 是否复选，true为多选，false为单选，不传值，默认展示纯列表 */
    isCheck?: boolean;
    /** 是否显示全选框（默认不显示） */
    isCheckAll?: boolean;
    /** 关键字查询 */ 
    showSearch?: boolean;

    defaultValue?: any[];
    /** 公司的唯一标识符 */

    keyid?: string;
    /** 组件显示的数据或字段 */

    titleKey?: string | ((value:any, index?:number) => string | JSX.Element);
} 
/**
 * 搜索状态
 */
export interface IRequestParams{

    /** 公司名字 */
    name?: string;
}

/** 公司选择 */
@connect((state: ReduxState): IReduxStatePart => ({loadingUrls: state.system.loadingUrls}))
export default class CompanySelection extends ModulesBasic <IProps, ModulesState> {

    public readonly state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction); 
    }

    /** 数据请求方法 */
    private get request(): (keywords: IRequestParams) => Promise <ICompanyInfo[]> {
        if(this.props.request) { 
            return this.props.request;
        } else {  
            return defaultRequest.bind(this);
        }
    }
    /** 用户选择的数据 */
    onSaveSelect = (list: ICompanyInfo[]) => {  
        ModulesAction.saveSelectData(list);
        if (this.props.onChange) {
            this.props.onChange(list);
        }
    }
    componentDidMount() {
        /** 我的网络 初始化列表 */
        this.initCompanyList();  
        /** 初始化被选中的值 */
        ModulesAction.saveSelectData(this.props.defaultValue);   
    }  
    /** 点击全选 */
    onCheckAllChange = (e) => {
        let _allList = this.state.list.map((item)=> item[this.getkeyid]);
        this.onSaveSelect(e.target.checked ? _allList : []); 
    }
    /** 全选:加法 */
    onBtnCheckAll = () => {
        let currentCheckList = this.state.list.map((item)=> item[this.getkeyid]);
        // 合并之前选择的list 
        let _allList = ModulesAction.concatEqual(currentCheckList, this.state.selectRows);
        this.onSaveSelect(_allList); 
    }
    /** 点击保存按钮 */
    onSaveClick = () => {
        // 本地制造进度条 
        ModulesAction.setSubmit();
        setTimeout(() => {
            if (this.props.onSubmitCompany) {
                /** 组装成对象传出 */
                let _objs = []; 
                let listAll = this.state.listAll;  
                this.state.selectRows.forEach((item)=>{
                    for (let i = 0; i < listAll.length; i++){ 
                        if(listAll[i][this.getkeyid] === item){
                            _objs.push(listAll[i]);
                            break;
                        }
                    }
                });
                ModulesAction.cancelSubmit();
                this.props.onSubmitCompany(_objs);
            } 
        }, 500);
    }
    /** 取消全选: 减法 */
    onBtnChecNone = () => {  
        let currentCheckList = this.state.list.map((item)=> item[this.getkeyid]);
        let agoSelectedList = this.state.selectRows;
        for (let i = 0; i < currentCheckList.length; i++){  
            if(agoSelectedList.indexOf(currentCheckList[i])>=0){
                agoSelectedList.splice(agoSelectedList.indexOf(currentCheckList[i]), 1);
            }  
        }
        this.onSaveSelect(agoSelectedList); 
    }
    /** 选中事件 */
    onCheckChange = (e) => {     
        let selectedRows = this.state.selectRows;
        if (e.target.checked) { // 新增
            selectedRows.push(e.target.value[this.getkeyid]);
        } else { // 移除
            var length = selectedRows.length;
            for(var i = 0; i < length; i++){ 
                if(selectedRows[i] === e.target.value || selectedRows[i] === e.target.value[this.getkeyid])
                {  
                    selectedRows.splice(i,1); //删除下标为i的元素
                    break;
                }
            }
        } 
        this.onSaveSelect(selectedRows); 
    }
    onRadioChange = (e) => {   
        // this.onSaveSelect([e.target.value[this.getkeyid]]); 
        this.onSaveSelect([e.target.value]);
    }   

    onSearchName = (keywords) => {   
        let keyname = 'name'; // 默认关键字查询的字段名
        if(this.props.titleKey && typeof(this.props.titleKey) === 'string') {
            keyname = this.props.titleKey;
        }
        this.initCompanyList({[keyname]: keywords}); 
        ModulesAction.setKeywords(keywords);
        // ModulesAction.pageListCompany({fuzzyConnectionName: keywords});
    }
    render() {  
        const {isCheck, loadingUrls} = this.props;     
        const keywords = this.state.keywords;
        const isCheckAllTempNum =  this.currentCheckedNum(this.state.list, this.state.selectRows); // this.state.selectRows && this.state.selectRows.length;//
        return (
            <ModulesRoot action={ModulesAction}>
                <div className={`${css.modules} companyComp`}>
                    <Layout>
                        {this.props.showSearch &&
                            <Header className={css.liner}>
                                <div className={`fontsise12`}>
                                    <Search placeholder="请输入公司名称进行快速查找" onSearch={this.onSearchName} /> 
                                </div>
                            </Header>
                        }
                        { isCheck === undefined &&  
                            <Header className={css.liner}>
                                <div className={`fontsise12 ${css.shownumtitle}`}>
                                <Icon type="left" className={css.backicon} style={{cursor: 'pointer'}} onClick={this.onSaveClick}/> 可见企业（{this.state.list.length}）
                                </div>
                            </Header>
                        }
                        <Spin spinning={false}>
                        {/* <Spin spinning={loadingUrls.size > 0}>   */}
                            <Content> 
                                {isCheck === false ? 
                                    <CompanyRaido getTitle={this.getTitle} keywords={keywords} onChange={this.onRadioChange} getkeyid={this.getkeyid}/> : 
                                    <div> 
                                        {this.props.isCheckAll === true && 
                                            <Checkbox 
                                                style={{display: 'none'}}
                                                indeterminate={this.state.indeterminate}
                                                onChange={this.onCheckAllChange}
                                                checked={this.state.checkAll}
                                            >
                                                全选
                                            </Checkbox>
                                        } 
                                        <CompanyCheck 
                                            getTitle={this.getTitle} 
                                            keywords={keywords}
                                            checkIsSelect={this.checkIsSelect} 
                                            onCheckChange={this.onCheckChange}
                                            loadingUrls={this.props.loadingUrls}
                                            isCheck={this.props.isCheck}
                                        />
                                    </div>
                                } 
                            </Content>
                        </Spin>
                        { isCheck !== undefined && 
                            <Footer>
                                <div className="operatebtn">
                                    {this.props.isCheck && <span>可见企业 ({isCheckAllTempNum}/{this.state.list.length}) </span>}
                                    { isCheck !== undefined && <Button className="ml-10 greendefaultbtn" onClick={this.onSaveClick} type="primary" loading={this.state.submit}>保存</Button> }
                                    {this.props.isCheck && <Button onClick={isCheckAllTempNum === this.state.list.length?this.onBtnChecNone:this.onBtnCheckAll } type="default" >
                                        {isCheckAllTempNum === this.state.list.length?'取消全选':'全选'}
                                    </Button> }
                                </div>
                            </Footer>
                        }
                    </Layout>  
                </div>
            </ModulesRoot>
        );
    }
    /** 获取标题 */
    private get getTitle():(value: any, index:number) => string | JSX.Element{
        if(typeof this.props.titleKey === 'function'){
            return this.props.titleKey;
        } else if(typeof this.props.titleKey === 'string'){
            return (value: any):string => {
                return value[this.props.titleKey as any];
            };
        } else {
            return (value: any): string => {
                return value['connectionName'];
            };
        }
    }
    /** 获取关键key(id,对象的唯一id) */
    private get getkeyid():string{
        return this.props.keyid || 'connectionId';
    }
    private checkIsSelect = (item) => { 
        let length = this.state.selectRows.length;  // this.props.defaultValue.length; // 
        let _keyid = this.getkeyid;
        for(var i = 0; i < length; i++){ 
            let _item = this.state.selectRows[i];
            if(_item[_keyid] === item[_keyid] || _item === item[_keyid])
            {       
                return true;
            }
        } 
        return false;
    }
    private initCompanyList = async (keywords?: IRequestParams) => { 
        try {
            const list: ICompanyInfo[] = await this.request(keywords);  
            if (!list) { return;} 
            ModulesAction.initSortList(list);
        } catch (er) {
            console.error('xxx');
            return;
        }
    }
    /** 当前被选中的可见企业 */
    private currentCheckedNum = (list, selects) => {
        // 去重复
        let num = 0;   
        for (let j = 0; j < list.length; j++) { 
            var length = selects.length;
            for(var i = 0; i < length; i++){ 
                if (list[j][this.getkeyid] === selects[i]){
                    num ++;  
                }
            } 
        }  
        return num;
    }
}

/** 默认数据请求 */
export const defaultRequest = async(): Promise <ICompanyInfo[]> => {
    const list = await ModulesAction.pageListCompany();   
    ModulesAction.initSortList(list);
    return null;
};



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/CompanySelection/index.tsx